export function getDynamicFooterInfo(period = 7) {
  const now = new Date();
  const futureDate = new Date(now.getTime() + period * 24 * 60 * 60 * 1000);
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const hour12 = hours % 12 || 12;
  const minuteStr = minutes < 10 ? `0${minutes}` : minutes;
  const monthShort = futureDate.toLocaleString('en-US', { month: 'short' });
  const day = futureDate.getDate();
  const year = futureDate.getFullYear();
  const dateStr = `${hour12}:${minuteStr} ${ampm}, ${monthShort} ${day}, ${year}`;

  return `<span>Your subscription will renew at ${dateStr}</span> unless canceled. No partial refunds applicable. You may cancel at any time and you will not be charged for the next subscription period.`;
}